import { useQuery } from '@apollo/client';
import { GET_LIST } from '../gqlSchemes/getList';

export function useGetList({
  perPage,
  filter = { title: '' },
}: {
  perPage: number;
  filter: { title: string; status?: string, patientId?: string, careTeamId?: string };
}) {
  const { data, called, loading, error, refetch, fetchMore } = useQuery(
    GET_LIST,
    {
      fetchPolicy: 'network-only',
      nextFetchPolicy: 'cache-and-network',
      variables: {
        filter,
        page: 0,
        perPage,
      },
    }
  );

  const loadMore = () => {
    fetchMore({
      variables: {
        filter,
        page:
          data?.planDefinition?.planDefinitionPagination?.pageInfo?.page + 1,
        perPage: 50,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return Object.assign({}, prev, {
          planDefinition: {
            planDefinitionPagination: {
              ...fetchMoreResult.planDefinition.planDefinitionPagination,
              items: [
                ...prev.planDefinition.planDefinitionPagination.items,
                ...fetchMoreResult.planDefinition.planDefinitionPagination
                  .items,
              ],
            },
          },
        });
      },
    });
  };

  if (error) console.warn(error.message);

  return {
    data,
    called,
    loading,
    refetch,
    fetchMore,
    loadMore,
  };
}
